import * as React from 'react'
import { useUpdateEffect } from 'react-use'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import { ProgressiveAsset } from '@syconium/little-miss-figgy'

import { InfiniteSlider } from '../../../../../brunswick/components/InfiniteSlider'
import { trackEvent } from '../../../../../lib/analytics'
import { useGoogleTagManager } from '../../../../../lib/hooks/useGoogleTagManager'
import { makeShopifyImageSrcSet, resizeShopifyImageSource } from '../../../../../lib/utils/images'
import { GalleryAsset, GalleryImageStateContainer } from '../contexts/GalleryImageStateContainer'

import { IProps } from './IProps'
import { CarouselProvider, StyledCarousel } from './styles'

const mobileImageSize = 600

export const GalleryImageCarousel: React.FC<IProps> = ({
  altText = '',
  hidePagination,
  isDraggable = true,
  isFullScreen,
  renderProductAsset,
  children,
  scrollableSlides,
}) => {
  const {
    allAssets,
    currentAssetIndex,
    isImageZoomShown,
    setCurrentImageIndex,
    shouldAnimateCarousel,
    showImageZoom,
  } = GalleryImageStateContainer.useContainer()
  const { pushGalleryImageChange } = useGoogleTagManager()

  const renderProductAssetDefault = React.useCallback(
    (asset: GalleryAsset, index: number): JSX.Element | null => {
      const src = resizeShopifyImageSource({
        height: mobileImageSize,
        source: asset.source,
        width: mobileImageSize,
      })

      const srcSet = makeShopifyImageSrcSet(asset.source, [100, 200, 300, 600, 750, 960])
      switch (asset.type) {
        case 'ProductImage':
          return (
            <ProgressiveAsset.Image
              {...trackEvent({
                action: 'zoom',
                category: 'gallery',
                label: `gallery-image-${index}`,
              })}
              alt={`${altText ? altText + ': ' : ''}${index + 1} of ${allAssets.length}`}
              data-image-type='gallery'
              srcSet={srcSet}
              src={src}
              fetchPriority={index === 0 ? 'high' : undefined}
            />
          )
        case 'ProductVideo':
          return (
            <ProgressiveAsset.Video
              displayPauseButton={true}
              displayMuteButton={asset.kind === 'ugc'}
              autoPlay
              muted
              playsInline
              loop
              src={asset.source}
            />
          )
        default:
          return null
      }
    },
    [allAssets.length, altText]
  )

  useUpdateEffect(() => {
    pushGalleryImageChange(currentAssetIndex + 1, allAssets.length)
  }, [currentAssetIndex])

  const renderAsset = renderProductAsset ?? renderProductAssetDefault

  return (
    <StyledCarousel {...{ isFullScreen }}>
      <CarouselProvider
        currentSlide={currentAssetIndex + 1}
        disableAnimation={!shouldAnimateCarousel}
        dragEnabled={isDraggable}
        isIntrinsicHeight
        lockOnWindowScroll={true}
        naturalSlideHeight={125}
        naturalSlideWidth={100}
        totalSlides={allAssets.length + 2}
      >
        <InfiniteSlider
          hidePagination={hidePagination}
          isImageZoomShown={isImageZoomShown}
          renderAsset={renderAsset}
          setCurrentImageIndex={setCurrentImageIndex}
          assets={allAssets}
          onClick={() => showImageZoom()}
          scrollableSlides={scrollableSlides}
        />
      </CarouselProvider>
      {children}
    </StyledCarousel>
  )
}
